//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sadasi from '@/api/promotores/sadasi.api'

export default {
  data() {
    return {
      loading: false,
      tipos_credito: [
        { value: 'bancario', label: 'Bancario' },
        { value: 'fovissste', label: 'FOVISSSTE' },
        { value: 'infonavit', label: 'INFONAVIT' },
        { value: 'otro', label: 'Otro' },
      ],
      prospecto: {
        usuario_id: null,
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        email: null,
        celular: null,
        tipo_credito: null,
        desarrollo_id: null
      }
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },

    hide() {
      this.$refs.dialog.hide()
    },

    async submit() {
      try {
        this.loading = true

        const response = await Sadasi.create(this.prospecto)

        this.$emit('ok', response)
      } finally {
        this.loading = false
      }
    }
  }
}
